import { useState } from "react";
import { format } from "date-fns";
import { CalendarDays, X } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Calendar } from "@/components/ui/calendar";
import { Button } from "@/components/ui/button";

const label = (r) => {
  if (r?.from && r?.to) return `${format(r.from, "dd MMM yyyy")} – ${format(r.to, "dd MMM yyyy")}`;
  if (r?.from) return `${format(r.from, "dd MMM yyyy")} – ...`;
  return "All Dates";
};

export const DateRangePicker = ({ value, onChange }) => {
  const [open, setOpen] = useState(false);
  const [draft, setDraft] = useState(value);
  const select = (r) => {
    setDraft(r);
    if (r?.from && r?.to) { onChange(r); setOpen(false); }
  };
  const clear = () => { setDraft(undefined); onChange(undefined); setOpen(false); };
  const active = value?.from && value?.to;
  return (
    <div className="flex items-center gap-1">
    <Popover open={open} onOpenChange={(o) => { setOpen(o); if (o) setDraft(undefined); }}>
      <PopoverTrigger asChild>
        <Button size="sm" data-testid="date-range-trigger"
          className={`gap-1.5 ${active ? "bg-amber-500/15 border border-amber-500/40 text-amber-200 hover:bg-amber-500/25" : "bg-slate-700 hover:bg-slate-600 text-slate-100"}`}>
          <CalendarDays className="h-4 w-4" />
          <span data-testid="date-range-label">{label(active ? value : draft)}</span>
        </Button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-auto p-0 bg-[#111D38] border-slate-700 text-slate-100" data-testid="date-range-popover">
        <div className="px-3 pt-3 text-[11px] text-slate-400">Pilih tanggal awal lalu tanggal akhir (berdasarkan PR Date)</div>
        <Calendar mode="range" numberOfMonths={2} selected={draft} onSelect={select} defaultMonth={value?.from}
          classNames={{ day_selected: "bg-amber-500 text-slate-900 hover:bg-amber-500 focus:bg-amber-500", day_range_middle: "aria-selected:bg-amber-500/20 aria-selected:text-amber-100", day_today: "border border-slate-500" }} />
        <div className="flex justify-end px-3 pb-3">
          <Button size="sm" variant="ghost" data-testid="date-range-reset" onClick={clear} className="text-slate-300 hover:text-amber-300">Reset / All Dates</Button>
        </div>
      </PopoverContent>
    </Popover>
    {active && (
      <Button size="icon" variant="ghost" data-testid="date-range-clear" onClick={clear} title="Clear date filter" className="h-8 w-8 text-amber-300 hover:text-amber-100">
        <X className="h-4 w-4" />
      </Button>
    )}
    </div>
  );
};
